// src/services/links/linksComponentService.js
// import QRCode from "qrcode";
import { formatShortLink } from "@/utils/shortLinkFormatter";
import { confirmAndDeleteLink, deleteLink } from "@/services/links/linkDeleteService";

/**
 * Formats a given short link using the short link formatting service.
 *
 * @param {string} shortLink - The short link to be formatted.
 * @return {string} Returns the formatted short link.
 */
export function formatShortLinkService(shortLink) {
    return formatShortLink(shortLink);
}

/**
 * Truncates a given URL if its length exceeds 60 characters.
 * If the URL is too long, it shortens the URL to 50 characters
 * and appends an ellipsis ("...") to indicate truncation.
 *
 * @param {string} url - The URL to be truncated.
 * @return {string} The original URL if its length is 60 characters or less,
 *                  or the truncated version with an ellipsis otherwise.
 */
export function truncateUrl(url) {
    return url.length > 50 ? url.substring(0, 40) + "..." : url;
}

/**
 * Updates the application's route to navigate to the "Link" page with the specified query parameters.
 *
 * @param {Object} vm - The Vue instance containing the router object.
 * @param {string} link - The link identifier to be sent as a query parameter.
 * @param {string} url - The URL to be sent as a query parameter.
 * @return {void} This function does not return a value.
 */
export function editLink(vm, link, url) {
    vm.$router.push({ name: "Link", query: { link, url } });
}

/**
 * Handles the confirmation and deletion of a link, updating the associated data set.
 *
 * @param {Object} vm - The Vue instance containing the data and methods.
 * @param {string|number} id - The identifier of the link to be confirmed and deleted.
 * @return {Promise<void>} Resolves once the confirmation and deletion process is complete.
 */
export async function confirmAndDeleteLinkService(vm, id) {
    await confirmAndDeleteLink(id, vm.$swal, (idToDelete) => {
        deleteLink(idToDelete, vm.dataLinks, (newLinks) => {
            vm.dataLinks = newLinks;
        });
    });
}

/**
 * Displays a modal with a QR code and a download link.
 *
 * @param {Object} vm - The Vue instance used to invoke the modal.
 * @param {Object} dataLink - The object containing data for the QR code.
 * @param {string} dataLink.qrCode - The URL of the QR code image.
 * @param {string} dataLink.short_link - The filename used for downloading the QR code image.
 * @return {Promise<void>} Resolves when the modal has been rendered.
 */
export async function showQRCodeModal(vm, dataLink) {
    await vm.$swal.fire({
        title: "Código QR",
        html: `
      <img src="${dataLink.qrCode}" alt="QR Code" style="max-width: 250px; max-height: 250px;"/>
      <br/>
      <br/>
      <a id="download-qr" href="${dataLink.qrCode}" download="${dataLink.short_link}.png" class="swal2-confirm swal2-styled" style="margin-top: 15px;">
        Download QR Code
      </a>
    `,
        showConfirmButton: false,
        showCloseButton: true,
        width: 400,
    });
}

/**
 * Initializes Bootstrap popovers for data links with long original links.
 * Popovers display the original link and provide copy functionality.
 *
 * @param {Object} vm The Vue instance containing the links and references.
 * @return {void} Does not return any value.
 */
// export function initPopovers(vm) {
//     vm.$nextTick(() => {
//         vm.dataLinks.forEach(link => {
//             if (link.original_link.length > 50) {
//                 const el = vm.$refs['popover-' + link.id_links];
//                 if (el && window.bootstrap && window.bootstrap.Popover) {
//                     const td = Array.isArray(el) ? el[0] : el;
//                     new window.bootstrap.Popover(td, {
//                         trigger: 'focus',
//                         placement: 'bottom',
//                         html: true,
//                         content: `<span class="copied-popover">${link.original_link} <br><span class="copied-text">Copied!</span></span>`,
//                     });
//
//                     td.addEventListener('show.bs.popover', () => {
//                         navigator.clipboard.writeText(link.original_link);
//                     });
//                 }
//             }
//         });
//     });
// }
